<template>
    <md-drawer :md-active.sync="showNavigation" v-on:md-closed="handleClose">
        <md-toolbar class="md-transparent" md-elevation="0">
            <span class="md-title">My App name</span>
        </md-toolbar>

        <md-list>
            <md-list-item @click="handleClick('/')">
                <md-icon>home</md-icon>
                <span class="md-list-item-text">Home</span>
            </md-list-item>

            <div v-if="loggedIn">
                <md-list-item @click="handleClick('/borrow')">
                    <md-icon>post_add</md-icon>
                    <span class="md-list-item-text">Add Post</span>
                </md-list-item>
                <md-list-item @click="handleClick('/user')">
                    <md-icon>account_circle</md-icon>
                    <span class="md-list-item-text">My Account</span>
                </md-list-item>
                <md-list-item @click="handleClick('/getVerified')">
                    <md-icon>star</md-icon>
                    <span class="md-list-item-text">Get Verified</span>
                </md-list-item>
            </div>

            <div v-else>
                <md-list-item @click="handleClick('/login')">
                    <md-icon>account_circle</md-icon>
                    <span class="md-list-item-text">Log In or Sign Up</span>
                </md-list-item>
            </div>

            <md-divider></md-divider>
            <md-list-item @click="handleClick('/about')">
                <md-icon>info</md-icon>
                <span class="md-list-item-text">About</span>
            </md-list-item>
        </md-list>
    </md-drawer>
</template>

<script>
    import bus from '../bus'

    export default {
        name: "drawer",
        props: ['showNavigation'],
        data() {
            return {
                loggedIn: false,
                verified: localStorage.getItem('verified')
            }
        },
        methods: {
            handleClick(route) {
                this.$router.push(route);
                this.$props.showNavigation = false;
                this.handleClose();
            },
            handleClose () {
                bus.$emit('closeDrawer')
            }
        },
        mounted() {
            const now = new Date().getTime();
            const refreshTime = localStorage.expiry - 3600000;
            if(!localStorage.token || now > refreshTime) {
                this.loggedIn = false
            } else {
                this.loggedIn = true
            }
            bus.$on('loginStatus', (loginStatus) => {
                this.loggedIn = loginStatus
            });
        }
    }
</script>

<style scoped>
</style>